import {
  TablePage,
} from 'src/views/aceisf/xbsngsubmstatussearch'
import pathMap from 'src/paths/pathMap'

class AceIsfXbsngSubmStatusSearchRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ACEISF_XBSNG_SUBM_STATUS_SEARCH_LIST_VIEW,
        component: TablePage
      }
    ]
  }
}

export default AceIsfXbsngSubmStatusSearchRoute
